import {convertToArray, isArrayEqual, isNullOrUndefined} from "../../../common/utils";
import {getInputValuesFromGivenCondition} from "./getInputValuesFromGivenCondition";

export const KeyConditionInputModificationType = {
  unedited: "unedited",
  added: "added",
  deleted: "deleted",
  modified: "modified",
};

export function differenceBetweenTwoKeyConditions(keyCondition, editedKeyCondition) {
  function newAttribute(attribute, keyConditionValue, editedKeyConditionValue) {
    let changeType = KeyConditionInputModificationType.unedited;
    if (isNullOrUndefined(keyConditionValue) && !isNullOrUndefined(editedKeyConditionValue)) {
      changeType = KeyConditionInputModificationType.added;
    } else if (
        !isNullOrUndefined(keyConditionValue) &&
        isNullOrUndefined(editedKeyConditionValue)
    ) {
      changeType = KeyConditionInputModificationType.deleted;
    } else {
      if(!isArrayEqual(convertToArray(keyConditionValue),convertToArray(editedKeyConditionValue))){
        changeType = KeyConditionInputModificationType.modified;
      }
    }
    return {
      [attribute]: {
        changeType: changeType,
        previousValue: keyConditionValue,
        newValue: editedKeyConditionValue,
      },
    };
  }

  const inputValuesForKeyCondition = getInputValuesFromGivenCondition(keyCondition);
  const inputValuesForEditedKeyCondition = getInputValuesFromGivenCondition(editedKeyCondition);

  let differenceBetween2KeyConditions = {};
  function addInDifferenceBetween2KeyConditions(attribute) {
    if (isNullOrUndefined(differenceBetween2KeyConditions[attribute])) {
      const previousValue = inputValuesForKeyCondition[attribute];
      const newValue = inputValuesForEditedKeyCondition[attribute];
      differenceBetween2KeyConditions = {
        ...differenceBetween2KeyConditions,
        ...newAttribute(attribute, previousValue, newValue),
      };
    }
  }

  for (let attribute in inputValuesForKeyCondition) {
    addInDifferenceBetween2KeyConditions(attribute);
  }
  for (let attribute in inputValuesForEditedKeyCondition) {
    addInDifferenceBetween2KeyConditions(attribute);
  }

  return differenceBetween2KeyConditions;
}
